// extracted by mini-css-extract-plugin
module.exports = {"fj9lnf5":"fj9lnf5","hidden-captcha-badge":"hidden-captcha-badge","grecaptcha-badge":"grecaptcha-badge","ins7ygp":"ins7ygp","b6awkwe":"b6awkwe","c13okmgj":"c13okmgj"};